<style scoped>
  select option:disabled {
    color: antiquewhite;
  }
</style>

<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-md-12 d-lg-flex justify-content-end">
          <div class="date-range-picker-wrap d-flex mb-lg-0 mb-3 w-xs-100" style="width: 304px">
            <CustomerDateRangePicker
              class="w-xs-100"
              :date.sync="date"
              @update="getDifference()"></CustomerDateRangePicker>
          </div>
          <div
            class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
            style="width: 180px;">
            <select class="form-control" v-model="period" @change="getPeriod()">
              <option value>{{$lang.messages.all_day}}</option>
              <option>{{$lang.messages.custome_period}}</option>
            </select>

            <div
              class="text-center custom-select-dd d-inline-block mt-1 mb-2 w-xs-100 w-100"
              style
              v-if="isShow">
              <vue-timepicker
                v-model="filterObj.to_time"
                @change="getList(1)"
                :placeholder="$lang.messages.start_time"
                format="HH:mm"
              ></vue-timepicker>
            </div>

            <div
              class="text-right custom-select-dd text-center custom-select-dd d-inline-block mt-1 mb-2 w-xs-100 w-100"
              style
              v-if="isShow">
              <vue-timepicker
                v-model="filterObj.from_time"
                @change="getList(1)"
                :placeholder="$lang.messages.end_time"
                format="HH:mm"
              ></vue-timepicker>
            </div>
          </div>
          <div
            class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
            style="width: 180px;">
            <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
              <option value>{{$lang.messages.all_stores}}</option>
              <option v-for="store in storeList" :key="store.id" :value="store.id">{{store.name}}</option>
            </select>
          </div>
          <div
            class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
            style="width: 180px;">
            <select v-model="filterObj.employee_id" @change="getList(1)" class="form-control">
              <option value>{{$lang.messages.all_employees}}</option>
              <option
                v-for="employee in employeeList"
                :key="employee.id"
                :value="employee.id">{{employee.name}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card rounded-5">
            <div class="card-body">
              <div class="report-tab">
                <nav class="mb-4">
                  <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a
                      class="nav-item nav-link active text-center"
                      id="nav-tab1"
                      data-toggle="tab"
                      href="#tab1"
                      role="tab"
                      aria-controls="tab1"
                      aria-selected="true"
                      @click="setCanvas('lineChart', $lang.messages.gross_sale)">
                      <span class="tab-sub d-block">{{$lang.messages.gross_sales}}</span>
                      <span class="count d-block f-bold text-nowrap">
                        <vue-numeric
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="gross_sale"
                          :read-only="true"/>
                      </span>
                      <!-- <span class="count-avg">{{gross_sale_percentage}}</span> -->
                    </a>
                    <a
                      class="nav-item nav-link"
                      id="nav-tab2"
                      data-toggle="tab"
                      href="#tab2"
                      role="tab"
                      aria-controls="tab2"
                      aria-selected="false"
                      @click="setCanvas('refundChart', $lang.messages.refund)"
                    >
                      <span class="tab-sub d-block">{{$lang.messages.refunds}}</span>
                      <span class="count d-block f-bold text-nowrap">
                        <vue-numeric
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="refund"
                          :read-only="true"
                        />
                      </span>
                      <!-- <span class="count-avg">{{refund_percentage}}</span> -->
                    </a>
                    <a
                      class="nav-item nav-link"
                      id="nav-tab3"
                      data-toggle="tab"
                      href="#tab3"
                      role="tab"
                      aria-controls="tab3"
                      aria-selected="false"
                      @click="setCanvas('discountChart', $lang.messages.discount)"
                    >
                      <span class="tab-sub d-block">{{$lang.messages.discounts}}</span>
                      <span class="count d-block f-bold text-nowrap">
                        <vue-numeric
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="discount"
                          :read-only="true"
                        />
                      </span>
                      <!-- <span class="count-avg">{{discount_percentage}}</span> -->
                    </a>
                    <a
                      class="nav-item nav-link"
                      id="nav-tab4"
                      data-toggle="tab"
                      href="#tab4"
                      role="tab"
                      aria-controls="tab4"
                      aria-selected="false"
                      @click="setCanvas('netsalechart', $lang.messages.net_sale)"
                    >
                      <span class="tab-sub d-block">{{$lang.messages.net_sales}}</span>
                      <span class="count d-block f-bold text-nowrap">
                        <vue-numeric
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="net_sale"
                          :read-only="true"
                        />
                      </span>
                      <!-- <span class="count-avg">{{net_sale_percentage}}</span> -->
                    </a>

                    <a
                      class="nav-item nav-link"
                      id="nav-tab5"
                      data-toggle="tab"
                      href="#tab5"
                      role="tab"
                      aria-controls="tab5"
                      aria-selected="false"
                      @click="setCanvas('grossprofitChart', $lang.messages.gross_profit)"
                    >
                      <span class="tab-sub d-block">{{$lang.messages.gross_profit}}</span>
                      <span class="count d-block f-bold text-nowrap">
                        <vue-numeric
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="gross_profit"
                          :read-only="true"
                        />
                      </span>
                      <!-- <span class="count-avg">{{gross_profit_percentage}}</span> -->
                    </a>
                  </div>
                </nav>
                <div class="tab-content" id="nav-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="tab1"
                    role="tabpanel"
                    aria-labelledby="nav-tab1">
                    <div class="pink-tape py-lg-2">
                      <div class="row">
                        <div class="col-lg-8 col-md-7 align-self-center">
                          <h3 class="font-22 mb-0">{{$lang.messages.gross_sales}}</h3>
                        </div>
                        <div class="col-lg-4 col-md-5">
                          <div class="row">
                            <div class="col-6">
                              <div class="form-group mb-0">
                                <div class="custom-select-dd dd-transparent">
                                  <select v-model="graph" class="form-control" @change="getList(1)">
                                    <option :selected="graph">{{$lang.messages.line}}</option>
                                    <option :selected="graph">{{$lang.messages.bar}}</option>
                                    <option :selected="graph">{{$lang.messages.pie}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="form-group mb-0 pl-3">
                                <div class="custom-select-dd dd-transparent">
                                  <select
                                    v-model="filterObj.type"
                                    class="form-control"
                                    @change="getList(1)">
                                    <option
                                      value="Hours"
                                      :disabled="!isHours"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.hours}}</option>
                                    <option
                                      value="Days"
                                      :disabled="(isHours || isQuarter || isYear)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.days}}</option>
                                    <option
                                      value="Weeks"
                                      :disabled="(isHours || isDays || isYear)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.week}}</option>
                                    <option
                                      value="Months"
                                      :disabled="(isHours || isDays || isWeek)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.month}}</option>
                                    <option
                                      value="Quarters"
                                      :disabled="(isHours || isDays || isWeek || isMonth)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.quarter}}</option>
                                    <option
                                      value="Years"
                                      :disabled="!isYear"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.year}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <canvas id="lineChart" class="chartjs-render-monitor"></canvas>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="nav-tab2">
                    <div class="pink-tape py-lg-1">
                      <div class="row">
                        <div class="col-lg-8 col-md-7 align-self-center">
                          <h3 class="font-22 mb-0">{{$lang.messages.refunds}}</h3>
                        </div>
                        <div class="col-lg-4 col-md-5">
                          <div class="row">
                            <div class="col-6">
                              <div class="form-group mb-0">
                                <div class="custom-select-dd dd-transparent">
                                  <select v-model="graph" class="form-control" @change="getList(1)">
                                    <option :selected="graph">{{$lang.messages.line}}</option>
                                    <option :selected="graph">{{$lang.messages.bar}}</option>
                                    <option :selected="graph">{{$lang.messages.pie}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="form-group mb-0 pl-3">
                                <div class="custom-select-dd dd-transparent">
                                  <select
                                    v-model="filterObj.type"
                                    class="form-control"
                                    @change="getList(1)"
                                  >
                                    <option
                                      value="Hours"
                                      :disabled="!isHours"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.hours}}</option>
                                    <option
                                      value="Days"
                                      :disabled="(isHours || isQuarter || isYear)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.days}}</option>
                                    <option
                                      value="Weeks"
                                      :disabled="(isHours || isDays || isYear)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.week}}</option>
                                    <option
                                      value="Months"
                                      :disabled="(isHours || isDays || isWeek)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.month}}</option>
                                    <option
                                      value="Quarters"
                                      :disabled="(isHours || isDays || isWeek || isMonth)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.quarter}}</option>
                                    <option
                                      value="Years"
                                      :disabled="!isYear"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.year}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <canvas
                        id="refundChart"
                        width="90"
                        height="30"
                        style="display: block; height: 100px; width: 100px;"
                        class="chartjs-render-monitor"
                      ></canvas>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="nav-tab3">
                    <div class="pink-tape py-lg-1">
                      <div class="row">
                        <div class="col-lg-8 col-md-7 align-self-center">
                          <h3 class="font-22 mb-0">{{$lang.messages.discounts}}</h3>
                        </div>
                        <div class="col-lg-4 col-md-5">
                          <div class="row">
                            <div class="col-6">
                              <div class="form-group mb-0">
                                <div class="custom-select-dd dd-transparent">
                                  <select v-model="graph" class="form-control" @change="getList(1)">
                                    <option :selected="graph">{{$lang.messages.line}}</option>
                                    <option :selected="graph">{{$lang.messages.bar}}</option>
                                    <option :selected="graph">{{$lang.messages.pie}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="form-group mb-0 pl-3">
                                <div class="custom-select-dd dd-transparent">
                                  <select
                                    v-model="filterObj.type"
                                    class="form-control"
                                    @change="getList(1)"
                                  >
                                    <option
                                      value="Hours"
                                      :disabled="!isHours"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.hours}}</option>
                                    <option
                                      value="Days"
                                      :disabled="(isHours || isQuarter || isYear)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.days}}</option>
                                    <option
                                      value="Weeks"
                                      :disabled="(isHours || isDays || isYear)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.week}}</option>
                                    <option
                                      value="Months"
                                      :disabled="(isHours || isDays || isWeek)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.month}}</option>
                                    <option
                                      value="Quarters"
                                      :disabled="(isHours || isDays || isWeek || isMonth)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.quarter}}</option>
                                    <option
                                      value="Years"
                                      :disabled="!isYear"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.year}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <canvas
                        id="discountChart"
                        width="90"
                        height="30"
                        style="display: block; height: 100px; width: 100px;"
                        class="chartjs-render-monitor"
                      ></canvas>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="nav-tab4">
                    <div class="pink-tape py-lg-1">
                      <div class="row">
                        <div class="col-lg-8 col-md-7 align-self-center">
                          <h3 class="font-22 mb-0">{{$lang.messages.net_sales}}</h3>
                        </div>
                        <div class="col-lg-4 col-md-5">
                          <div class="row">
                            <div class="col-6">
                              <div class="form-group mb-0">
                                <div class="custom-select-dd dd-transparent">
                                  <select v-model="graph" class="form-control" @change="getList(1)">
                                    <option :selected="graph">{{$lang.messages.line}}</option>
                                    <option :selected="graph">{{$lang.messages.bar}}</option>
                                    <option :selected="graph">{{$lang.messages.pie}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="form-group mb-0 pl-3">
                                <div class="custom-select-dd dd-transparent">
                                  <select
                                    v-model="filterObj.type"
                                    class="form-control"
                                    @change="getList(1)"
                                  >
                                    <option
                                      value="Hours"
                                      :disabled="!isHours"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.hours}}</option>
                                    <option
                                      value="Days"
                                      :disabled="(isHours || isQuarter || isYear)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.days}}</option>
                                    <option
                                      value="Weeks"
                                      :disabled="(isHours || isDays || isYear)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.week}}</option>
                                    <option
                                      value="Months"
                                      :disabled="(isHours || isDays || isWeek)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.month}}</option>
                                    <option
                                      value="Quarters"
                                      :disabled="(isHours || isDays || isWeek || isMonth)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.quarter}}</option>
                                    <option
                                      value="Years"
                                      :disabled="!isYear"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.year}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <canvas
                        id="netsalechart"
                        width="90"
                        height="30"
                        style="display: block; height: 100px; width: 100px;"
                        class="chartjs-render-monitor"
                      ></canvas>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="nav-tab5">
                    <div class="pink-tape py-lg-1">
                      <div class="row">
                        <div class="col-lg-8 col-md-7 align-self-center">
                          <h3 class="font-22 mb-lg-0">{{$lang.messages.gross_profit}}</h3>
                        </div>
                        <div class="col-lg-4 col-md-5">
                          <div class="row">
                            <div class="col-6">
                              <div class="form-group mb-0">
                                <div class="custom-select-dd dd-transparent">
                                  <select v-model="graph" class="form-control" @change="getList(1)">
                                    <option :selected="graph">{{$lang.messages.line}}</option>
                                    <option :selected="graph">{{$lang.messages.bar}}</option>
                                    <option :selected="graph">{{$lang.messages.pie}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="form-group mb-0 pl-3">
                                <div class="custom-select-dd dd-transparent">
                                  <select
                                    v-model="filterObj.type"
                                    class="form-control"
                                    @change="getList(1)"
                                  >
                                    <option
                                      value="Hours"
                                      :disabled="!isHours"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.hours}}</option>
                                    <option
                                      value="Days"
                                      :disabled="(isHours || isQuarter || isYear)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.days}}</option>
                                    <option
                                      value="Weeks"
                                      :disabled="(isHours || isDays || isYear)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.week}}</option>
                                    <option
                                      value="Months"
                                      :disabled="(isHours || isDays || isWeek)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.month}}</option>
                                    <option
                                      value="Quarters"
                                      :disabled="(isHours || isDays || isWeek || isMonth)"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.quarter}}</option>
                                    <option
                                      value="Years"
                                      :disabled="!isYear"
                                      :selected="filterObj.type"
                                    >{{$lang.messages.year}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <canvas
                        id="grossprofitChart"
                        width="90"
                        height="30"
                        style="display: block; height: 100px; width: 100px;"
                        class="chartjs-render-monitor"
                      ></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card rounded-5">
            <div class="pink-tape py-1 mt-3">
              <div class="row">
                <div class="col-lg-9 col-md-6 col-5 align-self-center">
                  <a
                    href="javascript:void(0)"
                    class="font-20 mb-0 text-regular text-hover-primary text-nowrap mr-2"
                    @click="getExport()"
                  >
                    {{$lang.messages.export}}
                    <i class="mdi mdi-download align-text-top"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="card-body table-responsive">
              <table class="table table-striped table-style-1">
                <thead>
                  <tr>
                    <th scope="col">Sr.no</th>
                    <th
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'date')"
                    >{{$lang.messages.date}}</th>
                    <th
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'gross_sale')"
                    >{{$lang.messages.gross_sales}}</th>
                    <th
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'refunds')"
                    >{{$lang.messages.refunds}}</th>
                    <th
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'net_sale')"
                    >{{$lang.messages.net_sales}}</th>
                    <th
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'discounts')"
                    >{{$lang.messages.discounts}}</th>
                    <th
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'cost_of_good')"
                    >{{$lang.messages.cost_of_goods}}</th>
                    <th
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'gross_profit')"
                    >{{$lang.messages.gross_profit}}</th>
                    <th
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'margin')"
                    >{{$lang.messages.margin}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(sales,i) in itemlist" :key="sales.id">
                    <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                    <td
                      v-if="sales.week"
                    >{{sales.week.split(' ')[0] | moment("MMM DD, YYYY")}} - {{sales.week.split(' ')[2] | moment("MMM DD, YYYY")}}</td>
                    <td v-else-if="sales.month">{{sales.month ? sales.month: '0'}}</td>
                    <td v-else-if="sales.year">{{sales.year}}</td>
                    <td v-else-if="sales.date">{{sales.date | moment("MMM DD, YYYY")}}</td>
                    <td v-else-if="sales.Hours">{{sales.Hours}}</td>
                    <td
                      v-else-if="sales.quarter"
                    >{{sales.quarter.split(' ')[0] | moment("MMM DD, YYYY")}} - {{sales.quarter.split(' ')[2] | moment("MMM DD, YYYY")}}</td>
                    <td>
                      <vue-numeric
                        v-bind:precision="precision"
                        :separator="decimal_separator"
                        :currency="currency"
                        :value="sales.gross_sale"
                        :read-only="true"
                      ></vue-numeric>
                    </td>
                    <td>
                      <vue-numeric
                        v-bind:precision="precision"
                        :separator="decimal_separator"
                        :currency="currency"
                        :value="sales.refunds"
                        :read-only="true"
                      ></vue-numeric>
                    </td>
                    <td>
                      <vue-numeric
                        v-bind:precision="precision"
                        :separator="decimal_separator"
                        :currency="currency"
                        :value="sales.net_sale"
                        :read-only="true"
                      ></vue-numeric>
                    </td>
                    <td>
                      <vue-numeric
                        v-bind:precision="precision"
                        :separator="decimal_separator"
                        :currency="currency"
                        :value="sales.discounts"
                        :read-only="true"
                      ></vue-numeric>
                    </td>
                    <td>
                      <vue-numeric
                        v-bind:precision="precision"
                        :separator="decimal_separator"
                        :currency="currency"
                        :value="sales.cost_of_good"
                        :read-only="true"
                      ></vue-numeric>
                    </td>
                    <td>
                      <vue-numeric
                        v-bind:precision="precision"
                        :separator="decimal_separator"
                        :currency="currency"
                        :value="sales.gross_profit"
                        :read-only="true"
                      ></vue-numeric>
                    </td>
                    <td>{{sales.margin ? sales.margin: '0'}}%</td>
                  </tr>
                </tbody>
              </table>
              <ErrorComponent @retry="retry()" ref="errorComonent" />
            </div>
          </div>
          <div class="page-bottom-pagination text-right">
            <Pagination
              @page-change="pageChange"
              @items-per-page-change="itemsPerPageChange()"
              ref="listPagination"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import CustomerDateRangePicker from '@/components/CustomerDateRangePicker'

import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import moment from "moment";
import VueCharts from "vue-chartjs";
import { Bar, Line } from "vue-chartjs";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import numeral from 'numeral';
import accounting from 'accounting-js';

export default {
  name: "SalesSummary",
  components: {
    Pagination,
    ErrorComponent,
    Alert,
    VueTimepicker,
    CustomerDateRangePicker
  },
  data() {
    return {
      chartOptionsBar: {},
      date: {
        startDate: "",
        endDate: ""
      },
      gross_sale: "",
      refund: "",
      discount: "",
      net_sale: "",
      gross_profit: "",
      lineMyChart: "",
      refundMyChart: "",
      discountMyChart: "",
      netsaleMyChart: "",
      grossProfitMyChart: "",
      grosssale: [],
      refunds: [],
      discounts: [],
      netsale: [],
      grossprofit: [],
      week: [],
      demo: [],
      month: [],
      year: [],
      quarter: [],
      grossdate: [],
      list: ["Hours", "total_amount", "count", "date"],
      hours: [],
      gross_sale_percentage: "",
      refund_percentage: "",
      discount_percentage: "",
      net_sale_percentage: "",
      gross_profit_percentage: "",
      time: "",
      period: "",
      isShow: false,
      decimal_separator: ".",
      precision: 0,
      currency: "",
      currentPage: 1,
      totalPage: 0,
      graph: this.$lang.messages.line,
      itemsPerPage: 10,
      itemlist: [],
      storeList: [],
      topItemList: [],
      employeeList: [],
      currentSorting: "",
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        employee_id: "",
        search: "",
        to_date: "",
        from_date: "",
        to_time: "",
        from_time: "",
        type: ""
      },
      canvas_id: "lineChart",
      show_data: this.$lang.messages.gross_sale,
      isHours: false,
      isDays: true,
      isWeek: false,
      isMonth: false,
      isQuarter: false,
      isYear: false,
      data: []
    };
  },
  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getPeriod() {
      if (this.period == this.$lang.messages.custome_period) {
        this.isShow = true;
      } else {
        this.filterObj.to_time = ""
        this.filterObj.from_time = ""
        this.isShow = false;
      }
    },
    getExport() {
      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({ _action: "/report/export_summary/" +
          localStorage.getItem("client_id") +
          queryParam
        , _fileName: 'export_summary.csv'})
    },
    setCanvas(id, show_data) {
      this.canvas_id = id;
      this.show_data = show_data;
      this.getList(1);
    },

    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },

    getRandomColor() {
        var letters = '0123456789ABCDEF'.split('');
        var color = '#';
        for (var i = 0; i < 6; i++ ) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    },

    getList(page, sortBy, orderBy, store_id) {
      if (this.lineMyChart) {
        this.lineMyChart.destroy();
        this.lineMyChart = ""
      }

      this.ishours = false;
      (this.grosssale = []),
        (this.refunds = []),
        (this.discounts = []),
        (this.netsale = []),
        (this.grossprofit = []),
        (this.week = []),
        (this.demo = []),
        (this.grossdate = []),
        (this.hours = []),
        (this.month = []),
        (this.quarter = []),
        (this.year = []),
        (this.filterObj.to_date = moment(String(this.date.startDate)).format(
          "Y-MM-DD"
        ));

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-MM-DD"
      );

      this.itemlist = [];
      this.currentPage = page;

      if (!this.filterObj.type) {
        this.filterObj.type = "Days";
      }

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }
      this.$api
        .getAPI({
          _action: "/report/summary/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj,
          _hide_loader: true
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.itemlist = res.list;
            this.gross_sale = res.gross_sale;
            this.refund = res.refund;
            this.discount = res.discount;
            this.net_sale = res.net_sale;
            this.gross_profit = res.gross_profit;
            this.gross_sale_percentage = res.gross_sale_percentage;
            this.refund_percentage = res.refund_percentage;
            this.discount_percentage = res.discount_percentage;
            this.net_sale_percentage = res.net_sale_percentage;
            this.gross_profit_percentage = res.gross_profit_percentage;
            this.week = []
            this.hours = []
            this.quarter = []
            this.month = []
            this.year = []
            this.grossdate = []
          }
          this.data = [];
          for (let i = 0; i < res.chart_list.length; i++) {
            if (this.show_data == this.$lang.messages.gross_sale) {
              this.data.push(res.chart_list[i].gross_sale);
            }
            if (this.show_data == this.$lang.messages.refund) {
              this.data.push(res.chart_list[i].refunds);
            }
            if (this.show_data == this.$lang.messages.discount) {
              this.data.push(res.chart_list[i].discounts);
            }
            if (this.show_data == this.$lang.messages.net_sale) {
              this.data.push(res.chart_list[i].net_sale);
            }
            if (this.show_data == this.$lang.messages.gross_profit) {
              this.data.push(res.chart_list[i].gross_profit);
            }

            if (this.filterObj.type == "Weeks") {
              this.week.push(res.chart_list[i].week);
            }
            if (this.filterObj.type == "Hours") {
              this.hours.push(res.chart_list[i].Hours);
            }
            if (this.filterObj.type == "Quarters") {
              this.quarter.push(res.chart_list[i].quarter);
            }
            if (this.filterObj.type == "Months") {
              this.month.push(res.chart_list[i].month);
            }
            if (this.filterObj.type == "Years") {
              this.year.push(res.chart_list[i].year);
            }
            if (this.filterObj.type == "Days") {
              this.grossdate.push(res.chart_list[i].date);
            }
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle("No Record Found");
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }

          if (this.filterObj.type == "Days") {
            if (this.graph == this.$lang.messages.bar) {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: this.grossdate,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data,
                      borderColor: "#0000FF",
                      fill: true
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.grossdate,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            } else if (this.graph == this.$lang.messages.pie) {
              this.data.map(data => data != 0? data : undefined);
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                  labels: this.grossdate,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data.map(data => data != 0? data : undefined),
                      backgroundColor: this.data.map(data => this.getRandomColor()),
                    }
                  ]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(chart.datasets[0].data[tooltipItem.index], accounting.settings);
                          }
                      }
                  }
                }
              });
            } else {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "line",
                data: {
                  labels: this.grossdate,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data,
                      borderColor: "#f87979",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.grossdate,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            }
          } else if (this.filterObj.type == "Hours") {
            if (this.graph == this.$lang.messages.bar) {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: this.hours,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data,
                      borderColor: "#0000FF",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.hours,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            } else if (this.graph == this.$lang.messages.pie) {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: 'doughnut',
                data: {
                  labels: this.hours,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data.map(data => data != 0? data : undefined),
                      backgroundColor: this.data.map(data => this.getRandomColor()),
                    }
                  ]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(chart.datasets[0].data[tooltipItem.index], accounting.settings);
                          }
                      }
                  }
                }
              });
            } else {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "line",
                data: {
                  labels: this.hours,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data,
                      borderColor: "#f87979",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.hours,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            }
          } else if (this.filterObj.type == "Weeks") {
            if (this.graph == this.$lang.messages.bar) {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: this.week,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data,
                      borderColor: "#0000FF",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.week,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            } else if (this.graph == this.$lang.messages.pie) {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                  labels: this.week,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data.map(data => data != 0? data : undefined),
                      backgroundColor: this.data.map(data => this.getRandomColor()),
                    }
                  ]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(chart.datasets[0].data[tooltipItem.index], accounting.settings);
                          }
                      }
                  }
                }
              });
            } else {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "line",
                data: {
                  labels: this.week,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data,
                      borderColor: "#f87979",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.week,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            }
          } else if (this.filterObj.type == "Months") {
            if (this.graph == this.$lang.messages.bar) {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: this.month,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data,
                      borderColor: "#0000FF",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.month,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            } else if (this.graph == this.$lang.messages.pie) {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                  labels: this.month,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data.map(data => data != 0? data : undefined),
                      backgroundColor: this.data.map(data => this.getRandomColor()),
                    }
                  ]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(chart.datasets[0].data[tooltipItem.index], accounting.settings);
                          }
                      }
                  }
                }
              });
            } else {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "line",
                data: {
                  labels: this.month,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data,
                      borderColor: "#f87979",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.month,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            }
          } else if (this.filterObj.type == "Quarters") {
            if (this.graph == this.$lang.messages.bar) {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: this.quarter,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data,
                      borderColor: "#0000FF",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.quarter,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            } else if (this.graph == this.$lang.messages.pie) {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                  labels: this.quarter,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data.map(data => data != 0? data : undefined),
                      backgroundColor: this.data.map(data => this.getRandomColor()),
                    }
                  ]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(chart.datasets[0].data[tooltipItem.index], accounting.settings);
                          }
                      }
                  }
                }
              });
            } else {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "line",
                data: {
                  labels: this.quarter,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data,
                      borderColor: "#f87979",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: true,
                          data: this.quarter,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            }
          } else if (this.filterObj.type == "Years") {
            if (this.graph == this.$lang.messages.bar) {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: this.year,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data,
                      borderColor: "#0000FF",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: false,
                          data: this.year,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            } else if (this.graph == this.$lang.messages.pie) {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                  labels: this.year,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data.map(data => data != 0? data : undefined),
                      backgroundColor: this.data.map(data => this.getRandomColor()),
                    }
                  ]
                },
                options: {
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(chart.datasets[0].data[tooltipItem.index], accounting.settings);
                          }
                      }
                  }
                }
              });
            } else {
              var ctx = document
                .getElementById(this.canvas_id)
                .getContext("2d");
              this.lineMyChart = new Chart(ctx, {
                type: "line",
                data: {
                  labels: this.year,
                  datasets: [
                    {
                      label: "# " + this.show_data,
                      data: this.data,
                      borderColor: "#f87979",
                      fill: false
                    }
                  ]
                },
                options: {
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          beginAtZero: false,
                          data: this.year,
                          callback: function(value, index, values) {
                            return numeral(value).format('0.0a');
                          }
                        }
                      }
                    ],
                    xAxes: [
                      {
                        gridLines: {
                          display: true
                        }
                      }
                    ]
                  },
                  tooltips: {
                      callbacks: {
                          label: function(tooltipItem, chart){
                              var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
                              return datasetLabel + ': ' + accounting.formatMoney(tooltipItem.yLabel, accounting.settings);
                          }
                      }
                  }
                }
              });
            }
          }
        });
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },
    getEmployeeList() {
      this.$api
        .getAPI({ _action: `/employee/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.employeeList = res.list;
          }
        })
        .catch(e => {});
    },
    retry() {
      this.getList(1);
    },
    getDifference() {
      var a = moment(this.date.startDate);
      var b = moment(this.date.endDate);

      this.filterObj.to_date = moment(String(this.date.startDate)).format("Y-MM-DD")
      this.filterObj.from_date = moment(String(this.date.endDate)).format("Y-MM-DD")

      this.isDays = false;
      this.isHours = false;
      this.isYear = false;
      this.isQuarter = false;
      this.isWeek = false;
      this.isMonth = false;

      if (b.diff(a, "days") == 0) {
        this.isHours = true;
        this.filterObj.type = "Hours";
      } else if (b.diff(a, "years") > 0){
        this.isYear = true;
        this.filterObj.type = "Years";
      } else if (b.diff(a, "quarters") > 0){
        this.isQuarter = true;
        this.filterObj.type = "Quarters";
      } else if (b.diff(a, "months") > 0){
        this.isMonth = true;
        this.filterObj.type = "Months";
      } else if (b.diff(a, "days") >= 9){
        this.isWeek = true;
        this.filterObj.type = "Weeks";
      } else {
        this.isDays = true;
        this.filterObj.type = "Days";
      }

      this.getList(1);
    }
  },
  mounted() {
    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
    this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;
    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    }

    accounting.settings = {
      symbol : "Rp",
      format: "%s %v",
      decimal : this.decimal_separator == ","? ".": ",",
      thousand: this.decimal_separator,
      precision : this.precision
    }
    this.getDifference();
    this.getStoreList();
    this.getEmployeeList();

  }
}
</script>
<style scoped>
.report-tab .nav-tabs .nav-link {
  margin: 0 15px;
}
</style>
